module.exports = __webpack_public_path__ + "static/media/min (2).fd0a9118.jpg";